import { JSX, useEffect, useState } from "react";
import { useDebounceCallback } from "usehooks-ts";
import {
  buildFiltersArray,
  FilterItem,
} from "@via/pages/account/admin/utils/helper.ts";

type UserFilterProps = {
  setColumnFilters: (prevFilters: FilterItem[]) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
};

export default function UserFilters({
  setColumnFilters,
  setPage,
  setPageSize,
}: UserFilterProps): JSX.Element {
  const [searchedUsername, setSearchedUsername] = useState("");
  const [searchedEmail, setSearchedEmail] = useState("");
  const [searchedInstitute, setSearchedInstitute] = useState("");

  const debouncedHandleUsernameChange = useDebounceCallback((value: string) => {
    if (value === searchedUsername) return;
    setPage(0);
    setPageSize(10);
    setSearchedUsername(value);
  }, 300);

  const debouncedHandleEmailChange = useDebounceCallback((value: string) => {
    if (value === searchedEmail) return;
    setPage(0);
    setPageSize(10);
    setSearchedEmail(value);
  }, 300);

  const debouncedHandleInstituteChange = useDebounceCallback(
    (value: string) => {
      if (value === searchedInstitute) return;
      setPage(0);
      setPageSize(10);
      setSearchedInstitute(value);
    },
    300
  );

  useEffect(() => {
    const filters = buildFiltersArray({
      username: { term: searchedUsername, operator: "like" },
      email: { term: searchedEmail, operator: "like" },
      institute: { term: searchedInstitute, operator: "like" },
    });

    setColumnFilters(filters);
  }, [searchedUsername, searchedEmail, searchedInstitute]);

  return (
    <div className="flex w-full gap-4 mt-3">
      <div className="flex-1">
        <input
          type="text"
          placeholder="Filter By Username"
          className="w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={""}
          onChange={e => debouncedHandleUsernameChange(e.target.value)}
        />
      </div>

      <div className="flex-1">
        <input
          type="text"
          placeholder="Filter By Email"
          className="w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={""}
          onChange={e => debouncedHandleEmailChange(e.target.value)}
        />
      </div>

      <div className="flex-1">
        <input
          type="text"
          placeholder="Filter By Institute"
          className="w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={""}
          onChange={e => debouncedHandleInstituteChange(e.target.value)}
        />
      </div>
    </div>
  );
}
